import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL;

export function getDocuments(clientid, userid, languageid) {
  return apiUtils
    .get(
      `${baseUrl}/Documents/LoadDocuments?clientid=${clientid}&userid=${userid}&languageid=${languageid}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function loadReportSignatures() {
  return apiUtils
    .get(`${baseUrl}/Documents/LoadReportSignatures`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function saveReportSignature(params) {
  return apiUtils
    .post(
      `${baseUrl}/Documents/SaveReportSignature?userId=${params.userId}&reportSignatureId=${params.reportSignatureId}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function loadUploadExample(id) {
  return apiUtils
    .get(`${baseUrl}/Documents/LoadUploadExample?id=${id}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function uploadDocument(userId, clientID, uploadTypeID, uploadFile) {
  return apiUtils
    .postMulti(
      `${baseUrl}/Documents/UploadDocument?userId=${userId}&clientID=${clientID}&uploadTypeID=${uploadTypeID}`,
      uploadFile,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function saveSignedReport(params) {
  return apiUtils
    .post(
      `${baseUrl}/Documents/SaveSignedReport?userId=${params.userId}&clientID=${params.clientID}&reportID=${params.reportID}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function loadCompletedDocument(filePath) {
  return apiUtils
    .get(`${baseUrl}/Documents/LoadCompletedDocument?filePath=${filePath}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function loadReport(params) {
  return apiUtils
    .get(
      `${baseUrl}/Documents/LoadReport?clientID=${params.clientID}&appointmentID=${params.appointmentID}&jurisdictionID=${params.jurisdictionID}&locationID=${params.locationID}&reportId=${params.reportId}&languageID=${params.languageID}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function saveCompletedReport(params) {
  //let strParams = `${baseUrl}/Documents/SaveCompletedReport?userId=${params.userId}&clientID=${params.clientID}&reportID=${params.reportID}&reportName=${params.reportName}&reportType=${params.reportType}&appointmentID=${params.appointmentID}&jurisdictionID=${params.jurisdictionID}&locationID=${params.locationID}&languageID=${params.languageID}`;
  return (
    apiUtils
      //.post(strParams)
      .post(`${baseUrl}/Documents/SaveCompletedReport`, params)
      .then(apiUtils.handleResponse)
      .catch(apiUtils.handleError)
  );
}

export function GetTemplateFileByDescription(languageId, fileDescription) {
  return apiUtils
    .get(
      `${baseUrl}/Documents/GetTemplateFileByDesc?languageId=${languageId}&fileDescription=${fileDescription}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function SaveUploadReport(
  userID,
  clientID,
  jurisdictionID,
  reportID,
  vehicleID,
  appointmentID,
  flattenForm,
  document,
) {
  return apiUtils
    .postMulti(
      `${baseUrl}/Documents/SaveUploadReport?userID=${userID}&clientID=${clientID}&jurisdictionID=${jurisdictionID}&reportID=${reportID}&vehicleID=${vehicleID}&appointmentID=${appointmentID}&flattenForm=${flattenForm}`,
      document,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getTemplate(languageId, file) {
  return apiUtils
    .get(
      `${baseUrl}/Documents/GetTemplateFileByDesc?languageId=${languageId}&fileDescription=${file}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getMissingInformation(clientId) {
  return apiUtils
    .get(`${baseUrl}/Documents/GetMissingInformation?clientId=${clientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateMissingInformation(obj) {
  return apiUtils
    .post(`${baseUrl}/Documents/UpdateMissingInformation`, obj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function loadISASummaryDetails(clientID,vehicleId,startDate,endData) {
  return apiUtils
    .get(`${baseUrl}/Documents/LoadISASummaryDetails?clientId=${clientID}&vehicleId=${vehicleId}&startDate=${startDate}&endDate=${endData}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
